import React from 'react';
import ScheduleReportsCard from './components/ScheduleReportsIndex.jsx';

const ScheduleReports = () => {
    return (
        <ScheduleReportsCard />
    )
}

export default ScheduleReports;
